<template>
  <div class="row gy-0 gx-10">
    <!--begin::Col-->
        <div class="text-center" v-if="loadingReceipt">
          <p  class="card-label page-title fw-bolder fs-3 mb-1 text-green">Please wait while we generate your receipt</p>
          <br>
          <br>
          <v-progress-circular

            size="45"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <p  class="card-label page-title fw-bolder text-center fs-3 mb-1 text-red" v-if="loadReceiptError">Error generating your receipt</p>
    <div class="col-xl-12" v-if="!loadingReceipt && !loadReceiptError" >
      <!--begin::General Widget 1-->
      <div class="mb-10" >

        <div class="" >
          <div class="card-header border-0">
            <h3 class="card-title align-items-center flex-column">
              <span
                v-if="success"
                class="card-label page-title fw-bolder fs-3 mb-1 text-green"
                >Order Confirmation</span
              >
              <span
                v-else
                class="card-label page-title fw-bolder fs-3 mb-1 text-red"
                >Payment Failed</span
              >
            </h3>
          </div>
        </div>

        <div class="spacer-y-10"></div>

        <div v-if="success" class="card col align-center col-xl-4 my-7">
          <div class="card-body py-6">
            <div class="tab-content">
              <!--begin::Tap pane-->
              <div
                class="tab-pane fade show active"
                id="kt_table_widget_5_tab_1"
              >
                <!--begin:Label-->
                <span class="d-flex me-2">
                  <svg
                    class="flex-column mx-3"
                    width="30"
                    height="42"
                    viewBox="0 0 43 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.4004 19.1714V21.0114C41.3979 25.3243 40.0014 29.5208 37.419 32.9751C34.8367 36.4294 31.2069 38.9564 27.0711 40.1792C22.9352 41.4021 18.5149 41.2552 14.4693 39.7606C10.4238 38.266 6.9697 35.5036 4.62231 31.8856C2.27492 28.2675 1.15997 23.9876 1.44374 19.6841C1.72752 15.3806 3.3948 11.2841 6.19695 8.00559C8.99909 4.72708 12.786 2.44221 16.9928 1.49174C21.1996 0.541267 25.6009 0.976121 29.5404 2.73145"
                      stroke="#7ECD7D"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M41.4004 5.01147L21.4004 25.0315L15.4004 19.0315"
                      stroke="#7ECD7D"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>

                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6 text-left"
                      >Thanks for ordering with PYB!</span
                    >
                    <span class="me-2">
                      <span class="">
                        <span class="fs-6"
                          >You will receive a confirmation email</span
                        >
                      </span>
                      <!--end:Info-->
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="card col align-center col-xl-4 my-7">
          <div class="card-body py-6">
            <div class="tab-content">
              <!--begin::Tap pane-->
              <div
                class="tab-pane fade show active"
                id="kt_table_widget_5_tab_1"
              >
                <!--begin:Label-->
                <span class="d-flex me-2">
                  <svg
                    class="flex-column mx-3"
                    width="54"
                    height="54"
                    viewBox="0 0 54 54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3063 1.16663H37.6963L52.8346 16.305V37.695L37.6963 52.8333H16.3063L1.16797 37.695V16.305L16.3063 1.16663Z"
                      stroke="#E21C1C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M34.752 19.25L19.252 34.75"
                      stroke="#E21C1C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.252 19.25L34.752 34.75"
                      stroke="#E21C1C"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span class="d-flex flex-column">
                    <span class="fw-bolder fs-6 text-left"
                      >Your payment was not successful</span
                    >
                    <span class="me-2">
                      <span class="">
                        <span class="fs-6"
                          >please ensure all the card details are correct</span
                        >
                      </span>
                      <!--end:Info-->
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col align-center">
            <span class="text-dark fs-1 fw-bolder">
              {{transaction.customerName}}
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col align-center">
            <span class="text-dark fs-1 fw-bolder">
              {{formattedDate}}
            </span>
          </div>
        </div>
        <ul class="nav row mb-10">
          <li class="nav-item col-12 col-lg mb-5 mb-lg-0">
          </li>
          <li class="nav-item col-12 col-lg mb-5 mb-lg-0">
            <a
              class="nav-link btn btn-color-gray-400 d-flex flex-center py-15"
              data-bs-toggle="tab"
              href="#kt_general_widget_1_1"
            >
              <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
              <img
                alt="help"
                src="@/assets/media/full-pink.png"
                class="h-lg-150px float-left"
              />

              <div class="bdetails details_barrel ms-5 w-100">
                <!-- <span class="card-label bigger-label fw-bolder text-dark mb-5 float-left">Barrel Name</span> -->

                <div class="rpy-4 px-6 mb-5">
                  <div class="d-flex flex-stack">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-1">
                        <div
                          class="
                            fs-6
                            fw-bold
                            text-gray-800
                            fw-bold
                            mb-0
                            me-1
                            text-align-left
                          "
                        >
                          Size
                        </div>
                      </div>
                      <!-- <div class="fs-7 text-muted">For single end product with paying users.</div> -->
                    </div>
                    <div class="text-nowrap">
                      <!-- <span class="text-muted fs-7 fw-bold me-n1">$</span> -->
                      <span class="text-dark fs-1 fw-bolder">{{
                        transaction.barrelSize
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="py-4 px-6 mb-5">
                  <div class="d-flex flex-stack">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-1">
                        <div
                          class="
                            fs-6
                            fw-bold
                            text-dark
                            fw-bold
                            mb-0
                            me-1
                            text-align-left
                          "
                        >
                          Total
                        </div>
                      </div>
                      <!-- <div class="fs-7 text-muted">For single end product with paying users.</div> -->
                    </div>
                    <div class="text-nowrap">
                      <span class="fs-1 fw-bolder text-dark">$ {{
                        transaction.total
                      }} {{transaction.currencyText}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </li>
          <li class="nav-item col-12 col-lg mb-5 mb-lg-0">
          </li>
        </ul>


        <div class="row" v-if="success">
          <div class="col col-4"></div>
          <div class="col">
            <div class="row">
              <div class="col
                          fs-6
                          fw-bold
                          text-gray-800
                          fw-bold
                          mb-0
                          me-1
                          text-align-left">
                Receipt Number
              </div>
              <div class="col">
                <span class="text-dark fs-3 fw-bolder">
                  {{transaction.receiptNo}}
                </span>

              </div>
            </div>
            <div class="row">
              <div class="col
                            fs-6
                            fw-bold
                            text-gray-800
                            fw-bold
                            mb-0
                            me-1
                            text-align-left">
                  Authorization Number
                </div>
                <div class="col">
                  <span class="text-dark fs-3 fw-bolder">
                    {{transaction.authorizationNumber}}
                  </span>

                </div>
            </div>
            <div class="row">
              <div class="col
                          fs-6
                          fw-bold
                          text-gray-800
                          fw-bold
                          mb-0
                          me-1
                          text-align-left">
                Card
              </div>
              <div class="col">
                <span class="text-dark fs-3 fw-bolder">
                  {{transaction.paddedCardNumber}}
                </span>

              </div>
            </div>
          </div>
          <div class="col col-2"></div>
        </div>

        <div v-if="showRetryPaymentButton" class="card plain-card col align-center col-xl-4 my-7 mt-15">
          <button
            class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
            @click="retryPayment"
            :disabled="this.loadingRetryPayment"
            >Retry Payment
            <span
                v-if="loadingRetryPayment"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
          </button>
        </div>

        <div class="card plain-card col align-center col-xl-4 my-7 mt-15">
          <router-link
            :to="{ name: 'MyBarrels' }"
            class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
            >Go to my barrels
          </router-link>
        </div>
      </div>
      <!-- mb-10 -->
      <!--end::General Widget 1-->
    </div>
    <!--end::Col-->
    <!--begin::Col-->

    <!--end::Col-->
<SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import Vue from "vue";
import dayjs from "dayjs";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";

export default Vue.extend({
  name: "OrderConfirmation",
  data() {
    return {
      barrelId: "",
      transactionId: "",
      paymentType: "",
      loadingReceipt: false,
      loadReceiptError: false,
      transaction: {
        success: true,
      },
      loadingRetryPayment: false
    };
  },
  mixins: [SnackbarNotifierMixin, ConfirmationModalMixin],
  components: {
    SnackbarNotifier
  },
  computed: {
    success() {
      if (this.transaction.success === undefined) {
        return true;
      }

      return this.transaction.success;
    },
    showRetryPaymentButton(){
      if(this.success){
        return false;
      }

      return this.paymentType === "order";
    },
    formattedDate(){
      if(!this.transaction.date){
        return "";
      }

      return dayjs(this.transaction.date).format("dddd, MMMM D, YYYY h:mm A");
    }
  },
  methods: {
    async retryPayment() {
        try {
          this.loadingRetryPayment = true;
          const link = await ApiService.Instance.retryOrderBarrelPayment({ barrelId: this.barrelId});
          if (!link) {
            this.showNotifier({
              message: `Unable To Proceed To Payment Portal`,
              snackbarType: "error"
            });
            return;
          }
          window.location.href = link.paynowproRedirectUrl;
          this.loadingRetryPayment = false;
        } catch (e) {
          this.showNotifier({
            message: "Failed To Retry The Payment",
            snackbarType: "error"
          });
          this.loadingRetryPayment = false;
          error(e);
        }
      },
      async getTransaction(barrelId, transactionId, paymentType){
        if(paymentType === "order"){
          return ApiService.Instance.getBarrelTransaction({
            barrelId,
            transactionId
          });
        }

        if(paymentType === "shipping"){
          return ApiService.Instance.getShippingTransaction({
            barrelId,
            transactionId
          });
        }

        if(paymentType === "customs"){
          return ApiService.Instance.getCustomsTransaction({
            barrelId,
            transactionId
          });
        }

        if(paymentType === "upgrade"){
          return ApiService.Instance.getUpgradeTransaction({
            barrelId,
            transactionId
          });
        }


        return ApiService.Instance.getShippingTransaction({
            barrelId,
            transactionId
          });
      }
  },
  async beforeMount() {
    try {
      this.barrelId = this.$route.params.barrelId;
      this.transactionId = this.$route.params.transactionId;
      this.paymentType = this.$route.params.paymentType;
      this.loadingReceipt= true;
      this.transaction = await this.getTransaction(this.barrelId, this.transactionId, this.paymentType);
      this.loadingReceipt= false;
    } catch (e) {
      this.loadingReceipt= false;
      this.loadReceiptError = true;
      error(e);
    }
  },
});
</script>

<style></style>
